import { Component, InputSignal, input, computed } from '@angular/core';
import dayjs from 'dayjs';
import { DayjsFormatPipe } from '../../../../../pipes/date.pipe';
import { activityTypeLabels } from '../../../../organisms/activities/activities.constants';
import { Activity } from '../../../../organisms/activities/activities.types';

@Component({
  selector: 'app-check-in-item',
  templateUrl: './check-in-item.component.html',
  imports: [DayjsFormatPipe],
})
export class CheckInItemComponent {
  public readonly activity: InputSignal<Activity> = input.required();
  protected readonly dayjs = dayjs;

  readonly activityTypeLabel = computed(() => activityTypeLabels[(this, this.activity().type)]);
}
